// src/services/profiles/profileBootstrapApi.ts

import baseApi from "../../lib/baseApi";
import { ProfileMeType } from "@/types/profiles/profileMeTypes";

// Profile Me APIs ---------------------------------------------------------------
export const getProfileMeApi = async (): Promise<ProfileMeType> => {
  const res = await baseApi.get("/profiles/me/");
  return res.data;
};